
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
const meta = {};
const slug = '_resources';
const tableOfContents = [];

const layoutProps = {
  meta,
slug,
tableOfContents
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://tradly.app/api-headless-commerce"
        }}>{`More about Headless Commerce API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/TRADLY-PLATFORM"
        }}>{`Open source Repositories - iOS, Android, Web App`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.youtube.com/playlist?list=PLiKQzSFReAziYUvOKfUPxglX-HOhWabVi"
        }}>{`Youtube Video series on how to build a marketplace`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.youtube.com/watch?v=zLG1hZLxo3o"
        }}>{`VIDEO: Choosing the right stack and how to approach different solution`}</a></li>
      <li parentName="ul">{`Read: Why it’s `}<a parentName="li" {...{
          "href": "https://tradly.app/white-labeled-plug-and-play-c2c-marketplace-mobile-app-platform"
        }}>{`better to use pre-built solution like Tradly`}</a></li>
    </ul>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
